import { render, staticRenderFns } from "./Kompetenzrasterliste.vue?vue&type=template&id=f843d924&"
import script from "./Kompetenzrasterliste.vue?vue&type=script&lang=js&"
export * from "./Kompetenzrasterliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports